export default __webpack_public_path__ + "static/media/skolanalysis-02.98ffc3f2.png";